import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const resourceLinks = [
    { label: t('footer_spreadsheet'), href: '/cssbuy-spreadsheet/' },
    { label: t('footer_finds'), href: '/finds/' },
    { label: t('footer_categories'), href: '/categories/' },
    { label: t('footer_guides'), href: '/guides/' },
    { label: t('footer_shipping'), href: '/shipping/' },
    { label: t('footer_qc'), href: '/qc/' },
    { label: t('footer_reviews'), href: '/reviews/' },
    { label: t('footer_comparisons'), href: '/comparisons/' },
    { label: t('footer_safety'), href: '/safety/' },
  ];

  const companyLinks = [
    { label: t('footer_about'), href: '/about/' },
    { label: t('footer_contact'), href: '/contact/' },
    { label: t('footer_privacy'), href: '/privacy-policy/' },
    { label: t('footer_terms'), href: '/terms/' },
    { label: t('footer_disclaimer'), href: '/disclaimer/' },
    { label: t('footer_editorial'), href: '/editorial-policy/' },
  ];

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-lg font-bold tracking-tight">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center text-white text-sm font-bold">
                C
              </span>
              CSSBuy Spreadsheet
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {t('disclaimer')}
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors"
            >
              {t('footer_main_site')}
              <i className="ri-external-link-line" />
            </a>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-foreground-400 mb-4">
              {t('footer_resources')}
            </h3>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-foreground-400 mb-4">
              {t('footer_company')}
            </h3>
            <ul className="space-y-2.5">
              {companyLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t('footer_copyright')}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">
              {t('footer_language')}:
            </span>
            <div className="flex gap-2">
              {['pt', 'de', 'en'].map((lang) => (
                <button
                  key={lang}
                  onClick={() => changeLanguage(lang)}
                  className="text-xs text-foreground-400 hover:text-white transition-colors"
                >
                  {lang === 'pt' ? t('footer_lang_pt') : lang === 'de' ? t('footer_lang_de') : t('footer_lang_en')}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}